"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _validate = require("@/utils/validate");
var _merchantName = _interopRequireDefault(require("@/components/merchantName"));
var _vuex = require("vuex");
var _priceSetting = require("@/api/priceSetting.js");
var _monitoringConfig = require("@/api/priceSetting/priceMonitoring/monitoringConfig.js");
var _options = require("@/utils/options.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SpecificProductRulesFormComp',
  components: {
    merchantName: _merchantName.default
  },
  data: function data() {
    return {
      dialogVisible: false,
      // 是否显示弹框
      formType: 'update',
      // 表单类型：create - 新增 update - 修改
      formLoading: false,
      //  表单加载状态

      checkedIds: [],
      // 选中行商品id、规格id
      categoryProps: {
        // 商品分类属性
        value: 'id',
        label: 'name',
        children: 'childList',
        expandTrigger: 'hover',
        checkStrictly: false,
        emitPath: false,
        multiple: false
      },
      monitorRateIdOptions: _options.monitorRateIdOptions,
      // 监控频率
      platformIdsOptions: _options.platformIdsOptions,
      // 对比平台
      specialRuleIdsOptions: _options.specialRuleIdsOptions,
      // 特殊监控规则
      rulesForm: {
        // 表单数据
        id: null,
        productSkuItems: [],
        // 商品id和规格id
        monitorRateId: null,
        // 监控频率
        platformIds: [],
        // 对比平台
        raiseWarnRatio: null,
        // 上涨预警阈值(比例)
        decreaseWarnRatio: null,
        // 下降预警阈值(比例)
        raiseWarnFix: null,
        // 上涨预警阈值(固定值)
        decreaseWarnFix: null,
        // 下降预警阈值(固定值)
        specialRuleIds: [] // 特殊监控规则
      },
      rules: {
        monitorRateId: [{
          required: true,
          message: '请选择监控频率',
          trigger: ['change', 'blur']
        }],
        platformIds: [{
          required: true,
          message: '请选择对比平台',
          trigger: ['change', 'blur']
        }]
      }
    };
  },
  methods: {
    // 打开弹框
    open: function () {
      var _open = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(productId, skuId) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.dialogVisible = true;
              _context.p = 1;
              _context.n = 2;
              return (0, _priceSetting.getMonitorRuleDetailByProductSku)(productId, skuId);
            case 2:
              this.rulesForm = _context.v;
            case 3:
              _context.p = 3;
              this.formLoading = false;
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1,, 3, 4]]);
      }));
      function open(_x, _x2) {
        return _open.apply(this, arguments);
      }
      return open;
    }(),
    // 提交表单
    submitForm: (0, _validate.Debounce)(function () {
      var _this = this;
      // 校验表单
      this.$refs.formRef.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(valid) {
          var valids, hasValidValue;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.p = _context2.n) {
              case 0:
                if (valid) {
                  _context2.n = 1;
                  break;
                }
                return _context2.a(2);
              case 1:
                // 检查阈值要求
                valids = [_this.rulesForm.raiseWarnRatio, _this.rulesForm.decreaseWarnRatio, _this.rulesForm.raiseWarnFix, _this.rulesForm.decreaseWarnFix];
                hasValidValue = valids.some(function (val) {
                  return val !== null && val !== undefined && val !== '';
                });
                if (hasValidValue) {
                  _context2.n = 2;
                  break;
                }
                _this.$message.error('预警阈值需至少设置一个值！');
                return _context2.a(2);
              case 2:
                // 提交请求
                _this.formLoading = true;
                _context2.p = 3;
                _context2.n = 4;
                return (0, _monitoringConfig.savePriceMonitorRuleApi)(_this.rulesForm);
              case 4:
                _this.$message.success("".concat(_this.formType === 'create' ? '添加' : '修改', "\u6210\u529F\uFF01"));
                _this.dialogVisible = false;
                _this.$emit('success');
              case 5:
                _context2.p = 5;
                _this.formLoading = false;
                return _context2.f(5);
              case 6:
                return _context2.a(2);
            }
          }, _callee2, null, [[3,, 5, 6]]);
        }));
        return function (_x3) {
          return _ref.apply(this, arguments);
        };
      }());
    }),
    // 重置表单
    resetForm: function resetForm() {
      this.tableData = {
        data: [],
        total: 0
      };
      this.multipleSelection = [];
      this.checkedIds = [];
      this.rulesForm = {
        id: null,
        productSkuItems: [],
        // 商品id
        monitorRateId: null,
        // 监控频率
        platformIds: [],
        // 对比平台
        raiseWarnRatio: null,
        // 上涨预警阈值(比例)
        decreaseWarnRatio: null,
        // 下降预警阈值(比例)
        raiseWarnFix: null,
        // 上涨预警阈值(固定值)
        decreaseWarnFix: null,
        // 下降预警阈值(固定值)
        specialRuleIds: [] // 特殊监控规则
      };
      this.$refs.formRef.resetFields();
      this.formLoading = false;
    }
  }
};